import { AccountingReportType } from "./report-type";

export const REPORT_SETTINGS_DEFAULT_REPORT_KEY = "default";

export const REPORT_SETTINGS_REPORT_KEYS = [
    REPORT_SETTINGS_DEFAULT_REPORT_KEY,
    AccountingReportType.PROFIT_LOSS,
    AccountingReportType.BALANCE_SHEET,
    AccountingReportType.GENERAL_LEDGER,
    AccountingReportType.TRIAL_BALANCE,
    AccountingReportType.CASH_FLOW_STATEMENT,
    AccountingReportType.EXPENSE_BY_VENDOR,
    AccountingReportType.AR_AGING_SUMMARY,
    AccountingReportType.AR_AGING_DETAIL,
    AccountingReportType.SCHEDULES,
] as const;

export type ReportSettingsReportKey =
    (typeof REPORT_SETTINGS_REPORT_KEYS)[number];

export type ReportSettingsConcreteReportKey = Exclude<
    ReportSettingsReportKey,
    typeof REPORT_SETTINGS_DEFAULT_REPORT_KEY
>;

export const REPORT_SETTINGS_CONCRETE_REPORT_KEYS =
    REPORT_SETTINGS_REPORT_KEYS.filter(
        (key): key is ReportSettingsConcreteReportKey =>
            key !== REPORT_SETTINGS_DEFAULT_REPORT_KEY,
    );
